<template>
    <div>
        <el-form label-width="100px" :model="form" ref="form" :rules="rules">
            <el-form-item label="角色名称" prop="title">
                <el-input v-model="form.title" style="width: 300px" placeholder="请输入角色名称"></el-input>
            </el-form-item>
            <el-form-item label="权限管理" prop="desc">
                <el-tree :data="menus" check-strictly show-checkbox node-key="id" :props="defaultProps" ref="tree" highlight-current @check-change="handleChange">
                </el-tree>
            </el-form-item>
            <el-form-item>
                <el-button style="width: 120px" type="primary" @click="save">保存</el-button>
                <el-button style="width: 120px" @click="back">返回</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { add, detail, edit } from "@/api/auth/role";
import menus from "@/configs/menus";
export default {
    data() {
        return {
            menus,
            form: {
                title: "",
                desc: "",
            },
            keys: [],
            names: [],
            uuid: null,
            mapper: new Map(),
            defaultProps: {
                label: "name",
            },
            rules: {
                title: [{ required: true, message: "请输入角色名称" }],
            },
        };
    },
    mounted() {
        this.uuid = this.$route.query.uuid;
        if (this.uuid) {
            this.getDetail();
        }
        this.setMapper(this.menus);
    },
    methods: {
        getDetail() {
            detail({ uuid: this.uuid }).then(({ code, result, error }) => {
                if (code === 200) {
                    this.form.title = result.title;
                    this.keys = JSON.parse(result.desc).keys;
                    this.$nextTick(() => {
                        this.$refs.tree.setCheckedKeys(this.keys.split(","));
                    });
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleChange() {
            const checkedKeys = this.$refs.tree.getCheckedKeys();
            if (checkedKeys.length === 0) {
                this.keys = [];
            } else {
                this.keys = checkedKeys;
            }
        },
        setMapper(tree) {
            const deepIn = (arr) => {
                if (!arr) return;
                arr.map((x) => {
                    this.mapper.set(x.id, x.name);
                    deepIn(x.children);
                });
            };
            deepIn(tree);
        },
        save() {
            const checkedKeys = this.$refs.tree.getCheckedKeys();
            const halfCheckedKeys = this.$refs.tree.getHalfCheckedKeys();
            if (checkedKeys.length === 0) {
                this.keys = [];
            } else {
                this.keys = checkedKeys;
            }
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                const moduleKeys = checkedKeys.concat(halfCheckedKeys).filter((x) => x.indexOf("_") === -1);
                const moduleNames = [];
                moduleKeys.map((x) => {
                    moduleNames.push(this.mapper.get(x));
                });
                const keys = checkedKeys.join(",");
                const names = moduleNames.join(",");

                const params = {
                    title: this.form.title,
                    desc: JSON.stringify({ keys, names }),
                };
                if (this.uuid) {
                    params.uuid = this.uuid;
                    edit(params).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("编辑成功");
                            this.back();
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                } else {
                    add(params).then(({ code, error }) => {
                        if (code === 200) {
                            this.$message.success("添加成功");
                            this.back();
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                }
            });
        },
        back() {
            this.$router.back();
        },
    },
};
</script>

<style></style>
